import React, { useContext, useEffect, useState } from "react";
import { Input } from "../../Input";
import { Button } from "../../Button";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { ContainerChaveApi, ContainerConfiguracoes } from "./styles";
import Modal from "../../Modal/Modal";
import ModalChaveIntegracao from "./ModalChaveIntegracao/ModalChaveIntegracao";
import { ToggleConfigurar } from "../../Toggle/ToggleConfigurar/ToggleConfigurar";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import { AuthContext } from "../../../contexts/Auth/AuthContext";
import LockedIcon from "../../LockedIcon/LockedIcon";
import Swal from "sweetalert2";
import { boolean } from "../../../services/Functions";
import { Select } from "../../Select";

type ChaveIntegracaoProps = {
  chave: string;
  setChaveDeIntegracao: (newValue: string) => void;
};

const ChaveIntegracao: React.FC<ChaveIntegracaoProps> = ({
  chave,
  setChaveDeIntegracao,
}) => {
  const { theme } = useTheme();
  const [chaveApi, setChaveApi] = useState<string>(chave);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [mostrarChave, setMostrarChave] = useState<boolean>(false);

  const { configuracoes, setConfiguracoes } = useContext(ConfiguracoesContext);
  const { permissoesPlanos } = useContext(AuthContext);
  const permite2Niveis = permissoesPlanos["ADICIONAR_VARIACAO_SECUNDARIA"]?.permitido;
  const permiteSubcategorias = permissoesPlanos["SUBCATEGORIAS"]?.permitido;

  return (
    <>
      <ContainerChaveApi theme={theme}>
        <div className="descricao-texto fonteTexto">
          A chave de API permite que você conecte seu sistema de ERP ao Conecta Venda, facilitando a troca de informações de pedidos e produtos entre as plataformas.
        </div>
        <div className="bloco-input">
          {chaveApi && (
            <Input
              onChange={(newValue) => {
                setChaveApi(newValue);
              }}
              type={"password"}
              value={chaveApi}
              placeholder="Chave de integração"
              disabled
              allowCopy={true}
              label="Chave de API"
            ></Input>
          )}
          {!chaveApi && (
            <div className="pai-botao">
              <Button
                onClick={() => {
                  setIsModalOpen(true);
                }}
                className="btn-salvar"
                title={"Gerar chave"}
                width="fit-content"
              />
            </div>
          )}
        </div>
      </ContainerChaveApi>

      {chaveApi && (
        <ContainerConfiguracoes theme={theme}>
          <div className="texto fonteTexto">
            Selecione o que você deseja cadastrar através da API:
          </div>
          <label className="config">
            <ToggleConfigurar
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  integracao: {
                    ...configuracoes.integracao,
                    cadastrarProdutos: newValue,
                  },
                });
              }}
              value={configuracoes.integracao.cadastrarProdutos}
            />
            <div className="title fonteTexto">Produtos</div>
          </label>

          <label className="config">
            <ToggleConfigurar
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  integracao: {
                    ...configuracoes.integracao,
                    cadastrarImagens: newValue,
                  },
                });
              }}
              value={configuracoes.integracao.cadastrarImagens}
            />
            <div className="title fonteTexto">Imagens</div>
          </label>

          <label className="config">
            <ToggleConfigurar
              onChange={(newValue) => {
                if (!permite2Niveis) return;
                setConfiguracoes({
                  ...configuracoes,
                  integracao: {
                    ...configuracoes.integracao,
                    suporta_2_variacoes: newValue,
                  },
                });
              }}
              value={permite2Niveis ? (configuracoes.integracao.suporta_2_variacoes ?? false) : false}
            />
            <div className={`title fonteTexto${!permite2Niveis ? ' bloqueado' : ''}`}>
              Separar variações em 2 níveis <strong>(Ex: Tamanho + Cor)</strong>
            </div>
            {!permite2Niveis && (
              <LockedIcon
                mensagem="Recurso disponível a partir do plano Essencial."
                width="2.4rem"
                className="locked-icon"
              />
            )}
          </label>

          <label className="config">
            <ToggleConfigurar
              onChange={(newValue) => {
                if (!permiteSubcategorias) return;
                setConfiguracoes({
                  ...configuracoes,
                  integracao: {
                    ...configuracoes.integracao,
                    cadastrarSubcategoria: newValue,
                  },
                });
              }}
              value={permiteSubcategorias ? (configuracoes.integracao.cadastrarSubcategoria ?? false) : false}
            />
            <div className={`title fonteTexto${!permiteSubcategorias ? ' bloqueado' : ''}`}>Subcategoria</div>
            {!permiteSubcategorias && (
              <LockedIcon
                mensagem="Recurso disponível a partir do plano Essencial."
                width="2.4rem"
                className="locked-icon"
              />
            )}
          </label>
            <div className="title_ERP fonteTexto">
              ERP parceiro
            </div>
            <Select
              value={configuracoes.integracao.selecionarERP}
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  integracao: {
                    ...configuracoes.integracao,
                    selecionarERP: newValue,
                  },
                });
              }}
              disabled={true}
              options={[
                {name: configuracoes.integracao.selecionarERP, value: configuracoes.integracao.selecionarERP}
              ]}
            />

          <label className="config">
            <ToggleConfigurar
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  integracao: {
                    ...configuracoes.integracao,
                    webhook: {
                      ativo: newValue,
                      url: configuracoes.integracao.webhook?.url ?? "",
                    },
                  },
                });
              }}
              value={configuracoes.integracao.webhook?.ativo ?? false}
            />
            <div className="title fonteTexto">Webhook de pedidos</div>
          </label>

          {configuracoes.integracao.webhook?.ativo && (
            <Input
              onChange={(newValue) => {
                setConfiguracoes({
                  ...configuracoes,
                  integracao: {
                    ...configuracoes.integracao,
                    webhook: {
                      ativo: configuracoes.integracao.webhook?.ativo ?? false,
                      url: newValue,
                    },
                  },
                });
              }}
              type={"text"}
              value={configuracoes.integracao.webhook?.url ?? ""}
              placeholder="https://seu-sistema.com/webhook"
              label="URL do webhook"
            />
          )}
        </ContainerConfiguracoes>
      )}

      <Modal
        isOpen={isModalOpen}
        setModal={setIsModalOpen}
        children={
          <ModalChaveIntegracao
            setModalOpen={setIsModalOpen}
            onChange={(newValue: {
              chave: string;
              cadastrarProdutos: boolean;
              cadastrarImagens: boolean;
              cadastrarNivelSecundario: boolean;
              cadastrarSubcategoria: boolean;
              selecionarERP: string;
            }) => {
              setConfiguracoes({
                ...configuracoes,
                integracao: {
                  ...configuracoes.integracao,
                  cadastrarImagens: newValue.cadastrarImagens,
                  cadastrarProdutos: newValue.cadastrarProdutos,
                  suporta_2_variacoes: newValue.cadastrarNivelSecundario,
                  cadastrarSubcategoria: newValue.cadastrarSubcategoria,
                  selecionarERP: newValue.selecionarERP,
                },
              });
              setChaveDeIntegracao(newValue.chave);
              setChaveApi(newValue.chave);
              setIsModalOpen(false);
              setMostrarChave(true);
              Swal.fire({
                title: "Sucesso!",
                text: "Chave gerada com sucesso.",
                icon: "success",
                timer: 1250,
                showConfirmButton: false,
              });
            }}
          />
        }
        width="70rem"
        maxWidth="95vw"
        align="center"
        justify="center"
        animation="opacity 500ms cubic-bezier(0.4, 0, 0.2, 1)"
        padding="3rem 6rem"
      />
    </>
  );
};
export default ChaveIntegracao;
